import _classCallCheck from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { LongType, ScalarType } from "./reflection-info";
import { isOneofGroup } from "./oneof"; // noinspection JSMethodCanBeStatic

export var ReflectionTypeCheck = /*#__PURE__*/function () {
  function ReflectionTypeCheck(info) {
    _classCallCheck(this, ReflectionTypeCheck);

    var _a;

    this.fields = (_a = info.fields) !== null && _a !== void 0 ? _a : [];
  }

  _createClass(ReflectionTypeCheck, [{
    key: "prepare",
    value: function prepare() {
      if (this.data) return;
      var req = [],
          known = [],
          oneofs = [];

      var _iterator = _createForOfIteratorHelper(this.fields),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;

          if (field.oneof) {
            if (!oneofs.includes(field.oneof)) {
              oneofs.push(field.oneof);
              req.push(field.oneof);
              known.push(field.oneof);
            }
          } else {
            known.push(field.localName);

            switch (field.kind) {
              case "scalar":
              case "enum":
                if (!field.opt || field.repeat) req.push(field.localName);
                break;

              case "message":
                if (field.repeat) req.push(field.localName);
                break;

              case "map":
                req.push(field.localName);
                break;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.data = {
        req: req,
        known: known,
        oneofs: Object.values(oneofs)
      };
    }
    /**
     * Is the argument a valid message as specified by the
     * reflection information?
     *
     * Checks all field types recursively. The `depth`
     * specifies how deep into the structure the check will be.
     *
     * With a depth of 0, only the presence of fields
     * is checked.
     *
     * With a depth of 1 or more, the field types are checked.
     *
     * With a depth of 2 or more, the members of map, repeated
     * and message fields are checked.
     *
     * Message fields will be checked recursively with depth - 1.
     *
     * The number of map entries / repeated values being checked
     * is < depth.
     */

  }, {
    key: "is",
    value: function is(message, depth) {
      var _this = this;

      var allowExcessProperties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (depth < 0) return true;
      if (message === null || message === undefined || typeof message != 'object') return false;
      this.prepare();
      var keys = Object.keys(message),
          data = this.data; // if a required field is missing in arg, this cannot be a T

      if (keys.length < data.req.length || data.req.some(function (n) {
        return !keys.includes(n);
      })) return false;

      if (!allowExcessProperties) {
        // if the arg contains a key we dont know, this is not a literal T
        if (keys.some(function (k) {
          return !data.known.includes(k);
        })) return false;
      } // "With a depth of 0, only the presence and absence of fields is checked."
      // "With a depth of 1 or more, the field types are checked."


      if (depth < 1) {
        return true;
      } // check oneof group


      var _iterator2 = _createForOfIteratorHelper(data.oneofs),
          _step2;

      try {
        var _loop = function _loop() {
          var name = _step2.value;
          var group = message[name];
          if (!isOneofGroup(group)) return {
            v: false
          };
          if (group.oneofKind === undefined) return "continue";

          var field = _this.fields.find(function (f) {
            return f.localName === group.oneofKind;
          });

          if (!field) return {
            v: false
          }; // we found no field, but have a kind, something is wrong

          if (!_this.field(group[group.oneofKind], field, allowExcessProperties, depth)) return {
            v: false
          };
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
          if (typeof _ret === "object") return _ret.v;
        } // check types

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(this.fields),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var field = _step3.value;
          if (field.oneof !== undefined) continue;
          if (!this.field(message[field.localName], field, allowExcessProperties, depth)) return false;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return true;
    }
  }, {
    key: "field",
    value: function field(arg, _field, allowExcessProperties, depth) {
      var repeated = _field.repeat;

      switch (_field.kind) {
        case "scalar":
          if (arg === undefined) return _field.opt;
          if (repeated) return this.scalars(arg, _field.T, depth, _field.L);
          return this.scalar(arg, _field.T, _field.L);

        case "enum":
          if (arg === undefined) return _field.opt;
          if (repeated) return this.scalars(arg, ScalarType.INT32, depth);
          return this.scalar(arg, ScalarType.INT32);

        case "message":
          if (arg === undefined) return true;
          if (repeated) return this.messages(arg, _field.T(), allowExcessProperties, depth);
          return this.message(arg, _field.T(), allowExcessProperties, depth);

        case "map":
          if (typeof arg != 'object' || arg === null) return false;
          if (depth < 2) return true;
          if (!this.mapKeys(arg, _field.K, depth)) return false;

          switch (_field.V.kind) {
            case "scalar":
              return this.scalars(Object.values(arg), _field.V.T, depth, _field.V.L);

            case "enum":
              return this.scalars(Object.values(arg), ScalarType.INT32, depth);

            case "message":
              return this.messages(Object.values(arg), _field.V.T(), allowExcessProperties, depth);
          }

          break;
      }

      return true;
    }
  }, {
    key: "message",
    value: function message(arg, type, allowExcessProperties, depth) {
      if (allowExcessProperties) {
        return type.isAssignable(arg, depth);
      }

      return type.is(arg, depth);
    }
  }, {
    key: "messages",
    value: function messages(arg, type, allowExcessProperties, depth) {
      if (!Array.isArray(arg)) return false;
      if (depth < 2) return true;

      if (allowExcessProperties) {
        for (var i = 0; i < arg.length && i < depth; i++) {
          if (!type.isAssignable(arg[i], depth - 1)) return false;
        }
      } else {
        for (var _i = 0; _i < arg.length && _i < depth; _i++) {
          if (!type.is(arg[_i], depth - 1)) return false;
        }
      }

      return true;
    }
  }, {
    key: "scalar",
    value: function scalar(arg, type, longType) {
      var argType = typeof arg;

      switch (type) {
        case ScalarType.UINT64:
        case ScalarType.FIXED64:
        case ScalarType.INT64:
        case ScalarType.SFIXED64:
        case ScalarType.SINT64:
          switch (longType) {
            case LongType.BIGINT:
              return argType == "bigint";

            case LongType.NUMBER:
              return argType == "number" && !isNaN(arg);

            default:
              return argType == "string";
          }

        case ScalarType.BOOL:
          return argType == 'boolean';

        case ScalarType.STRING:
          return argType == 'string';

        case ScalarType.BYTES:
          return arg instanceof Uint8Array;

        case ScalarType.DOUBLE:
        case ScalarType.FLOAT:
          return argType == 'number' && !isNaN(arg);

        default:
          // case ScalarType.UINT32:
          // case ScalarType.FIXED32:
          // case ScalarType.INT32:
          // case ScalarType.SINT32:
          // case ScalarType.SFIXED32:
          return argType == 'number' && Number.isInteger(arg);
      }
    }
  }, {
    key: "scalars",
    value: function scalars(arg, type, depth, longType) {
      if (!Array.isArray(arg)) return false;
      if (depth < 2) return true;
      if (Array.isArray(arg)) for (var i = 0; i < arg.length && i < depth; i++) {
        if (!this.scalar(arg[i], type, longType)) return false;
      }
      return true;
    }
  }, {
    key: "mapKeys",
    value: function mapKeys(map, type, depth) {
      var keys = Object.keys(map);

      switch (type) {
        case ScalarType.INT32:
        case ScalarType.FIXED32:
        case ScalarType.SFIXED32:
        case ScalarType.SINT32:
        case ScalarType.UINT32:
          return this.scalars(keys.slice(0, depth).map(function (k) {
            return parseInt(k);
          }), type, depth);

        case ScalarType.BOOL:
          return this.scalars(keys.slice(0, depth).map(function (k) {
            return k == 'true' ? true : k == 'false' ? false : k;
          }), type, depth);

        default:
          return this.scalars(keys, type, depth, LongType.STRING);
      }
    }
  }]);

  return ReflectionTypeCheck;
}();